import { z } from 'zod'

import type { AccountSubType } from '../account-type'
import type { CountryCode } from '../countries'
import type { Currency } from '../currency'

import { accountSubTypes } from '../account-type'
import { countriesList } from '../countries'
import { currencies } from '../currency'
import { mt4Servers } from '../mt-server'

/** Schema for validating currency mappings. */
const currencyMapSchema = z.record(z.string(), z.string()).refine(
  (val) => {
    const keys = Object.keys(val)
    return keys.every((key) => currencies.includes(key as Currency))
  },
  { message: 'Currency map keys must be valid currency values' },
)

/** Schema for validating country-to-currency mappings. */
const countryMapSchema = z
  .object({
    default: currencyMapSchema,
  })
  .and(
    z.record(z.string(), currencyMapSchema).refine(
      (val) => {
        const keys = Object.keys(val).filter((key) => key !== 'default')
        return keys.every((key) => countriesList.includes(key as CountryCode))
      },
      { message: 'Country map keys must be valid country values' },
    ),
  )

/** Schema for validating account subtype-to-country mappings. */
export const subtypeMapSchema = z.record(z.string(), countryMapSchema).refine(
  (val) => {
    const keys = Object.keys(val)
    return keys.every((key) => accountSubTypes.includes(key as AccountSubType))
  },
  { message: 'Subtype map keys must be valid account sub type values' },
)

/** Zod schema for validating group assignment override configuration. */
export const groupAssignmentOverrideSchema = z.object({
  createdAt: z.coerce.date(),
  id: z.number(),
  name: z.string(),
  nonSwapMap: subtypeMapSchema.nullable(),
  partnerRemoteIds: z.array(z.number()),
  server: z.enum(mt4Servers),
  swapMap: subtypeMapSchema.nullable(),
  updatedAt: z.coerce.date(),
})
